module.exports = __webpack_public_path__ + "static/img/yanyu_icon.052a8d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yanyu_icon.png
// module id = er4Q
// module chunks = 1